import React from "react";
import { AppConfig, Enums } from "../../../helpers";
import { Images } from "../../";
import { replace } from "react-router-redux";

const LiveTracker = (props) => {
  const { sportEvent, history, match } = props;
  const onClick = () => {
    // /live/${Enums.Feed.Live}/1/Soccer
    // ${window.location.pathname}
    if (
      !match.params.liveTracker
    ) {
      history.push(
        `${window.location.pathname}/liveTracker=${sportEvent.eventId}`
      );
      window.scrollTo(0,0)
    } else if (
      match.params.liveTracker !== `${sportEvent.eventId}`
    ) {
      history.push(`liveTracker=${sportEvent.eventId}`);
      window.scrollTo(0,0)

    }
  };

  {
  }
  return (
    <div className="bet-rows-icon-container">
      <a className="stats plus" onClick={() => onClick()}>
        {/* <Icon type="bar-chart" className="icon" /> */}

        <img className="live-tracker-image" src={Images.LiveTrackerIcon} alt="live-tracker" />
      </a>
    </div>
  );
};

export default LiveTracker;
